<template>
    <v-container fluid>

        <v-card >

            <v-data-table
                    :headers="headers"
                    :items="history"
                    :options="tableOptions"
            >
                <template v-slot:item.actions="{ item }">
                    <v-icon class="mr-8"
                            @click="moveTo(item)"
                    >
                        code
                    </v-icon>
                </template>
            </v-data-table>
        </v-card>

    </v-container>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import {TRANSACTION_NS} from "@/store/modules/transaction/constants";
    import {getXML} from "@/requesters/apiV3Requesters";

    export default {
        name: "HistoryComponent",
        data: () => ({
            headers: [
                {text: '#', value: 'releaseNb'},
                {text: 'Date', value: 'messageDateTime'},
                {text: 'Version', value: 'version'},
                {text: 'Actions', value: 'actions', sortable: false}
            ],
            tableOptions: {
                itemsPerPage: 10,
                sortBy: ['releaseNb'],
                sortDesc: [true]
            }
        }),
        computed: {
            ...mapGetters(TRANSACTION_NS, [
                'anonymized',
                'history',
                'xml'
            ])
        },
        methods: {
            ...mapActions(TRANSACTION_NS, [
                'fetchHistory',
                'sendToPoslogValidation'
            ]),
            moveTo: function(version) {
                const params = {
                    transactionId : version.transactionID,
                    messageDateTime: version.messageDateTime,
                    version: version.version,
                    view: 'xml',
                    anonymized : this.anonymized ? 'anonymized' : 'raw'
                }

                this.$router.replace({
                    name: 'transactionView',
                    params
                });
            },
            sendToPV: function (version) {
                getXML(version.transactionID, version.messageDateTime, version.version, false)
                    .then(xml => this.sendToPoslogValidation(xml))
            }
        },
        created() {
            this.fetchHistory();
        }
    }
</script>